import {colorCodes} from 'definitions/constant'
import {SvgIcon} from './SvgIcon'

export const AccountIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#FF0033',
  classes,
}) => (
  <svg
    data-cy="account-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M10.6666 5.33317C10.6666 6.52979 9.69654 7.49984 8.49992 7.49984C7.3033 7.49984 6.33325 6.52979 6.33325 5.33317C6.33325 4.13655 7.3033 3.1665 8.49992 3.1665C9.69654 3.1665 10.6666 4.13655 10.6666 5.33317Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      strokeWidth={strokeWidth}
      d="M5.06498 12.8335H11.935C12.6963 12.8335 13.2827 12.1789 12.9272 11.5057C12.4042 10.5155 11.212 9.3335 8.49998 9.3335C5.78799 9.3335 4.59576 10.5155 4.07281 11.5057C3.71729 12.1789 4.3037 12.8335 5.06498 12.8335Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FileTextIcon: SvgIcon = ({
  width = 25,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '',
  classes,
}) => (
  <svg
    data-cy="account-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M8.25 19.25H16.75C17.8546 19.25 18.75 18.3546 18.75 17.25V9L14.5 4.75H8.25C7.14543 4.75 6.25 5.64543 6.25 6.75V17.25C6.25 18.3546 7.14543 19.25 8.25 19.25Z"
      stroke="#5E6366"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 9.25H14.25V5"
      stroke="#5E6366"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.25 15.25H14.75"
      stroke="#5E6366"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.25 12.25H14.75"
      stroke="#5E6366"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LogoutIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = colorCodes.gray1100,
  strokeWidth = 1.2,
  fillColor = 'none',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.25 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V19.25H15.25V12.75"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 19.25H19.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.75 9.25L19.25 7M19.25 7L16.75 4.75M19.25 7H13.75"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const WindowsIcon: SvgIcon = () => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.62548 1.85247L3.71194 1.43342L3.71324 4.29361L0.628181 4.31112L0.62548 1.85247ZM0.628143 8.18077L0.627977 5.72042L3.71014 5.74035L3.71245 8.60351L0.628143 8.18077ZM9.62374 4.24474L5.20514 4.27971V1.22092L9.62374 0.578014V4.24474ZM9.62388 9.42474L5.20429 8.80289L5.19849 5.77253L9.62487 5.77974L9.62388 9.42474Z"
      fill="white"
      stroke="white"
    />
  </svg>
)

export const AppleIcon: SvgIcon = () => (
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.82925 4.36844C2.18967 3.96266 2.69747 3.69339 3.3777 3.6503C3.68611 3.67155 3.95867 3.76093 4.23709 3.86666C4.27196 3.87991 4.30882 3.89431 4.34733 3.90936C4.58494 4.0022 4.88527 4.11956 5.16829 4.14026L5.23882 4.14542L5.30802 4.13081C5.59635 4.06995 5.89542 3.96265 6.15394 3.8699C6.24243 3.83815 6.32617 3.80811 6.4031 3.78222C6.73396 3.67085 7.0096 3.60613 7.28 3.62569C7.84806 3.67379 8.28273 3.85215 8.61298 4.15202C7.07894 5.52282 7.46454 7.87258 8.99879 8.85629C8.74964 9.4675 8.45387 10.0277 8.05441 10.4875L7.76541 10.7786C7.55852 10.987 7.3696 11.0528 7.19277 11.0619C6.99761 11.0719 6.77 11.0145 6.49986 10.8924L6.49989 10.8924L6.49288 10.8894C5.72404 10.5562 4.98787 10.5338 4.17181 10.8898L4.1718 10.8898L4.16732 10.8918C3.7804 11.0652 3.55721 11.0921 3.40866 11.0706C3.27159 11.0507 3.12446 10.9792 2.91117 10.7784C1.56089 9.32933 1.0057 7.52316 1.14621 6.09582C1.21641 5.38271 1.45691 4.78764 1.82925 4.36844ZM6.27278 2.10823C6.08472 2.29743 5.87759 2.4395 5.68546 2.52746C5.82959 1.90543 6.27311 1.39712 6.82477 1.15114C6.73516 1.51904 6.53203 1.84742 6.27278 2.10823Z"
      fill="white"
      stroke="white"
    />
  </svg>
)

export const ReleaseNotesIcon: SvgIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.45842 16.0418H13.5417C14.4622 16.0418 15.2084 15.2956 15.2084 14.3752V7.50016L11.6667 3.9585H6.45841C5.53794 3.9585 4.79175 4.70469 4.79175 5.62516V14.3752C4.79175 15.2956 5.53794 16.0418 6.45842 16.0418Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9999 7.70817H11.4583V4.1665"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.125 12.7085H11.875"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.125 10.2085H11.875"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ArrowUpRightIcon: SvgIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.25 15.25V6.75H8.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 7L6.75 17.25"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BookIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-black',
  strokeWidth = 20,
  fillColor = 'none',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M12.8333 3.83317C12.8333 3.46498 12.5349 3.1665 12.1667 3.1665H9.33333C8.59695 3.1665 8 3.76346 8 4.49984V12.8332L8.55229 12.2809C9.05238 11.7808 9.73066 11.4998 10.4379 11.4998H12.1667C12.5349 11.4998 12.8333 11.2014 12.8333 10.8332V3.83317Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.16663 3.83317C3.16663 3.46498 3.4651 3.1665 3.83329 3.1665H6.66663C7.40301 3.1665 7.99996 3.76346 7.99996 4.49984V12.8332L7.44767 12.2809C6.94758 11.7808 6.2693 11.4998 5.56206 11.4998H3.83329C3.4651 11.4998 3.16663 11.2014 3.16663 10.8332V3.83317Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BellIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-gray-1000',
  strokeWidth = 1.73,
  fillColor = 'none',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <g clipPath="url(#clip0_2517_16842)">
      <path
        d="M7.63208 18.9607C7.63208 18.9607 7.63208 22.6002 11.9995 22.6002C16.367 22.6002 16.367 18.9607 16.367 18.9607M19.6426 9.13304V12.0447L22.5542 18.2319H1.44482L4.35646 12.0447V9.13304C4.35646 4.9119 7.77837 1.48999 11.9995 1.48999C16.2207 1.48999 19.6426 4.9119 19.6426 9.13304Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2517_16842">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const PreviewIcon: SvgIcon = ({
  width = 48,
  height = 48,
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <g>
      <path
        d="M14.8125 9.5C14.8125 10.25 13.4095 14.1875 9 14.1875C4.59052 14.1875 3.1875 10.25 3.1875 9.5C3.1875 8.75 4.59052 4.8125 9 4.8125C13.4095 4.8125 14.8125 8.75 14.8125 9.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6875 9.5C10.6875 10.432 9.93198 11.1875 9 11.1875C8.06802 11.1875 7.3125 10.432 7.3125 9.5C7.3125 8.56802 8.06802 7.8125 9 7.8125C9.93198 7.8125 10.6875 8.56802 10.6875 9.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
